import React, { useState } from "react";import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReactHtmlParser from "html-react-parser";

const faqsData = [
  {
    question: "What is the Mystery Gift Box?",
    answer:
      "The Mystery Gift Box is a special offer where you can unlock a Bonus Cashback of up to ₹500 on your next transaction till 30th April 2026.",
  },
  {
    question: "How do I unlock & claim my Mystery Bonus?",
    answer:
      "To unlock the Mystery Bonus, you must first register and then shop from an eligible retailer that offers Cashback / Rewards. When you complete the transaction, wait 24 - 48 hours after it is tracked and reflected in “My Earnings” section on the CashKaro app. Once updated, your Mystery Bonus will unlock and can be claimed by tapping the gift box on this offer landing page.",
  },
  {
    question: "Can I unlock the Bonus on any transaction?",
    answer:
      "This offer does not apply to transactions from Amazon Recharge, Swiggy, and other stores where Cashback/ Rewards are unavailable. Any other successful transaction within the offer period will make you eligible to unlock the Bonus.",
  },
  {
    question: "Can I claim the Bonus more than once in a month?",
    answer:
      "No, each user is eligible for only one Mystery Bonus per month.",
  },
  {
    question:
      "What happens if I cancel my transaction after unlocking the Bonus?",
    answer:
      "If the qualifying transaction is returned, canceled, or violates the offer T&C, the Mystery Bonus unlocked through that transaction will not be confirmed. However, you can still make another valid transaction within the offer period to confirm and claim your Bonus.",
  },
  {
    question: "How long does it take for my Bonus to be credited?",
    answer:
      "The Bonus amount will be added to your CashKaro account within 48 – 72 hours of claiming. It will appear in Pending state in “My Earnings” section. The Bonus will be confirmed and credited within 10 days after the linked transaction is Confirmed and Validated.",
  },
  {
    question: "Can my Bonus be changed or canceled?",
    answer:
      "Once the Bonus is unlocked and claimed, it cannot be altered. However, if your qualifying transaction is canceled or invalid, and no other valid transaction is made during the offer period, the Bonus will be cancelled.",
  },
];

const termsData = [
    {
        question: "Eligibility Criteria",
        answer: `<ul>
        <li>This offer is valid only for users who have received official communication from CashKaro about it.</li>
        <li>Each user is eligible for only one Mystery Bonus per month.</li>
      </ul>`},
      {
        question: "Bonus Unlock & Tracking Process",
        answer: `<ul>
        <li>To unlock the Mystery Bonus, users must first register and then shop from an eligible retailer that offers Cashback / Rewards.</li>
        <li>Upon completing the transaction, users must wait 24 - 48 hours after it is added and reflected in the "My Earnings" section before their Mystery Bonus unlocks and can be claimed.</li>
        <li>The unlocked Mystery Bonus will be available for claiming on the offer landing page.</li>
        <li>The Bonus amount will be added to the user’s CashKaro account within 48 - 72 hours after the claim.</li>
        <li>It will be reflected in pending state in the “My Earnings” section of the user's account on the CashKaro app or website.</li>
        <li>The Bonus will be confirmed and credited within 10 days after the transaction linked to it is Confirmed and Validated.</li>
        <li>This offer does not apply to transactions from Amazon Recharge, Swiggy, and other stores where Cashback is unavailable.</li>
    
      </ul>`},
      {
        question: "Bonus Amount Allocation",
        answer: `<ul>
        <li>The Bonus is randomly assigned and can be up to ₹500. The assigned amount is final and cannot be changed or influenced.</li>
        <li>Only transactions made within the offer period will be eligible to unlock the Mystery Bonus.</li>
      </ul>`},
      {
        question: "Disqualification Criteria",
        answer: `<ul>
        <li>If the qualifying transaction is returned, canceled, or violates the offer T&C, the Mystery Bonus unlocked through that transaction will not be confirmed.</li>
        <li>However, the user can still complete another valid transaction within the offer period to confirm and claim their Bonus.</li>
        <li>CashKaro reserves the right to revoke the Bonus if fraudulent activity, misuse, or policy violations are detected.</li>
      </ul>`},
      {
        question: "Modification & Termination",
        answer: `<ul>
        <li>Changes to the terms, eligibility, or Bonus structure will be communicated at CashKaro’s discretion.</li>
      </ul>`},
      {
        question: "General Terms",
        answer: `<ul>
        <li>Participation in this offer constitutes acceptance of these terms and conditions. CashKaro’s decision regarding all aspects of the offer will be final and binding.</li>
      </ul>`},
];

const FAQSection = ({ faqs = faqsData }) => {
    const [expandedFaq, setExpandedFaq] = useState(false);
    const [expandedTerm, setExpandedTerm] = useState(false);
  
    const handleFaqChange = (panel) => (event, isExpanded) => {
      setExpandedFaq(isExpanded ? panel : false);
    };
  
    const handleTermChange = (panel) => (event, isExpanded) => {
      setExpandedTerm(isExpanded ? panel : false);
    };
  return (
    <>
      {/* FAQ SECTION */}
      <Box
        sx={{
          backgroundImage:
            "url(https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Union.png)",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundColor: "#403326",
          px: "18px",
          pt: "50px",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <img
            src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/FAQs.png"
            alt="FAQs"
            style={{ width: "62px" }}
          />
        </Box>

        {faqs.map((faq, i) => (
          <Box key={i} mt={2.5}  px={2}>
            <Accordion
              expanded={expandedFaq === i}
              onChange={handleFaqChange(i)}
              sx={{
                background: "transparent",
                color: "#fff",
                fontWeight: 700,
                fontFamily: "Metropolis",
                boxShadow: "none",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <Typography
                    sx={{
                      fontSize: "22px",
                      fontWeight: 700,
                      color: "#fff",
                      transition: "0.2s ease",
                    }}
                  >
                    {expandedFaq === i ? "−" : "+"}
                  </Typography>
                }
              >
                {faq.question}
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  color: "#FFEEC3",
                  fontWeight: 500,
                  fontSize: "13px",
                  lineHeight: "18px",
                  fontFamily: "Metropolis",
                }}
              >
                {ReactHtmlParser(faq.answer)}
              </AccordionDetails>
            </Accordion>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img
                src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Vector.png"
                alt="faqs"
                style={{ width: "100%" }}
              />
            </Box>
          </Box>
        ))}
      </Box>

      {/* DIVIDER */}
      <Box sx={{background:"#403326"}}>
      <Box py={2} display="flex" justifyContent="center">
        <img
          src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Divider.png"
          alt="divider"
          style={{ width: "80%" }}
        />
      </Box>

      {/* TERMS SECTION */}
      <Box px="18px" pb={16}>
        <Typography
          sx={{
            textAlign: "center",
            py: 2,
            fontFamily: "Averia Serif Libre",
            color: "#fff",
            fontSize: "25px",
            fontWeight: 700,
            letterSpacing: "3px",
          }}
        >
          Terms & Conditions
        </Typography>

        {termsData.map((term, i) => (
          <Box key={i} mb={2} px={2}>
            <Accordion
              expanded={expandedTerm === i}
              onChange={handleTermChange(i)}
              sx={{
                background: "transparent",
                color: "#fff",
                fontWeight: 700,
                fontFamily: "Metropolis",
                boxShadow: "none",
              }}
            >
              <AccordionSummary
                expandIcon={
                  <Typography
                    sx={{
                      fontSize: "22px",
                      fontWeight: 700,
                      color: "#fff",
                      transition: "0.2s ease",
                    }}
                  >
                    {expandedTerm === i ? "−" : "+"}
                  </Typography>
                }
              >
                {term.question}
              </AccordionSummary>

              <AccordionDetails
                sx={{
                  color: "#FFEEC3",
                  fontWeight: 500,
                  fontSize: "13px",
                  lineHeight: "18px",
                  fontFamily: "Metropolis",
                }}
              >
                {ReactHtmlParser(term.answer)}
              </AccordionDetails>
            </Accordion>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img
                src="https://d2sriifpjiqv0p.cloudfront.net/mystery-box/Vector.png"
                alt="faqs"
                style={{ width: "100%" }}
              />
            </Box>
          </Box>
        ))}
      </Box>
      </Box>
    </>
  );
};

export default FAQSection;